export class NewCampaignFilter{
    name: String;
    value: any;
}